export const FirebaseConfig = {
  apiKey: "AIzaSyB2iqqWRiRcC50-RO1IOcYfOl4hYCgqYdM",
  authDomain: "portofolio-8ec44.firebaseapp.com",
  databaseURL: "https://portofolio-8ec44.firebaseio.com",
  projectId: "portofolio-8ec44",
  storageBucket: "portofolio-8ec44.appspot.com",
  messagingSenderId: "539865497397",
}
